<div
    class="d-flex justify-content-center align-items-center"
    [ngClass]="{
        'sc-text-success': isPositive,
        'sc-text-danger': !isPositive,
        'sc-text-bold': useBoldFont
    }"
>
    <cmps-icon
        [style.color]="iconColour"
        svgIcon="close-circle-outline"
        *ngIf="showIcon && !isPositive"
    ></cmps-icon>
    <cmps-icon
        [style.color]="iconColour"
        svgIcon="check-circle-outline"
        *ngIf="showIcon && isPositive"
    ></cmps-icon>
    <span [class.ml-2]="showIcon">{{ label }}</span>
</div>
